// The third state every fetched section needs, alongside "loading" and
// "loaded but empty": *failed*. Without it a failed fetch either spins
// forever or — worse — renders the empty-state copy, telling a player they
// have no friends/no games when all that happened is a request fell over.
//
// Deliberately quiet: one line, no heading, no icon. A broken corner of a
// page is not a page-level alarm. Pass onRetry wherever re-running the fetch
// is cheap and side-effect free.
interface LoadErrorProps {
	message: string
	onRetry?: () => void
}

export function LoadError({ message, onRetry }: LoadErrorProps) {
	return (
		// .inline so the bar hugs its sentence instead of painting a full-width
		// slab across the page.
		<div class="alert danger inline">
			<span>{message}</span>
			{onRetry && (
				<button type="button" class="link" onClick={onRetry}>
					Retry
				</button>
			)}
		</div>
	)
}
